/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';
import type { TransactionsTransactionAccount } from './TransactionsTransactionAccount';
import {
    TransactionsTransactionAccountFromJSON,
    TransactionsTransactionAccountFromJSONTyped,
    TransactionsTransactionAccountToJSON,
} from './TransactionsTransactionAccount';

/**
 * 
 * @export
 * @interface AccountKycStatusOutput
 */
export interface AccountKycStatusOutput {
    /**
     * 
     * @type {TransactionsTransactionAccount}
     * @memberof AccountKycStatusOutput
     */
    transactions?: TransactionsTransactionAccount;
    /**
     * 
     * @type {Links}
     * @memberof AccountKycStatusOutput
     */
    links?: Links;
    /**
     * 
     * @type {Error}
     * @memberof AccountKycStatusOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the AccountKycStatusOutput interface.
 */
export function instanceOfAccountKycStatusOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountKycStatusOutputFromJSON(json: any): AccountKycStatusOutput {
    return AccountKycStatusOutputFromJSONTyped(json, false);
}

export function AccountKycStatusOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountKycStatusOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionsTransactionAccountFromJSON(json['transactions']),
        'links': !exists(json, '_links') ? undefined : LinksFromJSON(json['_links']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AccountKycStatusOutputToJSON(value?: AccountKycStatusOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionsTransactionAccountToJSON(value.transactions),
        '_links': LinksToJSON(value.links),
        'error': value.error,
    };
}

